import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import RoundedButton from 'Components/ComponentLibrary/Atoms/Inputs/RoundedButton';
import { stepMap } from 'Views/Page/Content/Modal/Layouts/TotpRegistration/Layout';
import Typography from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Typography';
import BulletList from 'Components/ComponentLibrary/Molecules/BulletList';
import CenteredActions from 'Views/Page/Content/Modal/Components/CenteredActions';
import { getBorder } from 'Components/utils';
import useEventTrackingLogEvent, { categories, eventTypes } from 'EventTracking/useEventTrackingLogEvent';

const styles = (theme) => ({
  root: {},
  secret: {
    marginTop: theme.spacing(4),
    textAlign: 'center',
    padding: theme.spacing(2),
    backgroundColor: theme.palette.facet.lightGray,
    ...getBorder(theme, {
      all: true,
      color: theme.palette.facet.mediumGray,
    }),
    borderRadius: theme.radius.sm,
  },
  stepTitle: {
    paddingBottom: theme.spacing(2),
  },
});

const BackupCode = ({
  className,
  classes,
  changeState,
}) => {
  const { resource } = useMetaLayoutContext();
  const { logStandardizedEvent } = useEventTrackingLogEvent();

  return (
    <Box
      className={classNames(classes.root, className)}
    >
      <Typography
        variant={'h4'}
        weight={'bold'}
        className={classes.stepTitle}
      >
        {'Open & Configure the App'}
      </Typography>
      <BulletList
        listItems={[
          'Add a new site in your authenticator app',
          'Enter this code to add Facet',
        ]}
      />
      <Typography
        className={classes.secret}
        disabled
        test={'security-settings-authenticatorApp-register-modal-secret'}
      >
        {resource.attr('secret')}
      </Typography>
      <CenteredActions>
        <RoundedButton
          fullWidth
          onClick={() => {
            logStandardizedEvent(categories.userSettingsSecurity, eventTypes.clickButton, 'Auth Factor Authenticator: Enter verification code');
            changeState(stepMap.enterVerificationCode);
          }}
          test={'security-settings-button-authenticatorApp-register-modal-continue'}
        >
          {'Continue'}
        </RoundedButton>
      </CenteredActions>
    </Box>
  );
};

BackupCode.defaultProps = {
  className: '',
};

BackupCode.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  changeState: PropTypes.func.isRequired,
};

export default withStyles(styles)(BackupCode);
